import { Placement } from '@floating-ui/react';
import {
    RiArrowDownSFill,
    RiArrowLeftSFill,
    RiArrowRightSFill,
    RiArrowUpSFill,
} from '@remixicon/react';
import { ComponentProps, forwardRef, ReactNode } from 'react';
import { cn } from '~/helpers/tw';

interface TooltipContentProps extends Omit<ComponentProps<'ul'>, 'content'> {
    type?: 'list' | 'text';
    content: ReactNode;
    position: Placement;
}

const TooltipContent = forwardRef<HTMLUListElement, TooltipContentProps>(
    ({ type = 'text', position, content, className, ...props }, ref) => (
        <div className="relative">
            {/* Arrow */}
            {
                {
                    top: (
                        <RiArrowDownSFill
                            size={32}
                            className="absolute -bottom-4 left-0 w-full text-gray-950 dark:text-gray-500"
                        />
                    ),
                    bottom: (
                        <RiArrowUpSFill
                            size={32}
                            className="absolute -top-4 left-0 w-full text-gray-950 dark:text-gray-500"
                        />
                    ),
                    left: (
                        <RiArrowRightSFill
                            size={32}
                            className="absolute -right-4 top-0 h-full text-gray-950 dark:text-gray-500"
                        />
                    ),
                    right: (
                        <RiArrowLeftSFill
                            size={32}
                            className="absolute -left-4 top-0 h-full text-gray-950 dark:text-gray-500"
                        />
                    ),
                }[position.split('-')[0]]
            }

            {/* The actual list */}
            <ul
                {...props}
                ref={ref}
                className={cn(
                    className,
                    'min-w-0 max-w-56 overflow-hidden rounded-sm bg-gray-950 px-2 py-1 text-xs text-gray-50 shadow dark:bg-gray-500 dark:text-gray-950',
                    {
                        'list-none marker:text-gray-50 dark:marker:text-gray-950':
                            type === 'list',
                    }
                )}
            >
                {content}
            </ul>
        </div>
    )
);

TooltipContent.displayName = 'TooltipContent';

export default TooltipContent;
